<template>
  <el-form
    ref="feesForStopForm"
    :model="model"
    :rules="rules"
    label-width="12em"
    label-position="left"
    class="fees-for-stop-form"
  >
    <div class="el-form--inline">
      <BillingYm v-model="billingYm" :required="true" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" />
      <BillToCode v-model="billToCode" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autocomplete-list="autocompleteCustomerCodeSet" />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <!-- <ActionType v-model="actionType" label="着離陸入出庫" placeholder="区分" :required="!searchMode" :disabled="editMode" :initialize="true" mode="all" @change="changeActionType()"/> -->
      <!-- <DateTime v-model="actionTime" label="着離陸入出庫" placeholder="日時" prop="action_time" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" /> -->
      <ActionType v-model="actionType" label="着離陸・入出庫区分" :required="!searchMode" :disabled="editMode" mode="normal" @change="changeActionType($event)"/>
      <RegistrationSymbol v-model="registrationSymbol" :required="!searchMode" :searchCond="searchMode"
        :disabled="editMode" :autocomplete-list="autocompleteRegistrationSymbolSet" />
    </div>
    <!-- <DateTime v-model="actionTime" label="着離陸入出庫" placeholder="日時" prop="action_time" :required="!searchMode" :searchCond="searchMode"  mode="normal" :disabled="editMode" /> -->
    <template v-if='formMode === "search"'>
      <DateTimeRange :dateTimeFrom.sync="actionTimeFrom" :dateTimeTo.sync="actionTimeTo" label="着離陸・入出庫日時" prop="action_time"
        :required="!searchMode" :searchCond="searchMode" mode="normal" :disabled="editMode" />
    </template>
    <template v-else>
      <div class="el-form--inline">
        <DateTime v-model="actionTime" label="着離陸・入出庫日時" prop="action_time"
          :required="!searchMode" :searchCond="searchMode" mode="normal" :disabled="editMode" />
        <!-- <Blank /> -->
        <template v-if="editDisabledMode && !searchMode">
          <template v-if='(actionType === "1" || actionType === "8")'>
            <template v-if='(actionType === "1")'>
              <BillingExclusion v-model="billingExclusion" label="請求除外" prop="billing_exclusion_flag" :initialize="true"
                placeholder="請求除外時のみ選択" :clearable="true" :disabled="editMode" codeId="BILLING_EXCLUSION_ARR"/>
            </template>
            <template v-if='(actionType === "8")'>
              <BillingExclusion v-model="billingExclusion" label="請求除外" prop="billing_exclusion_flag" :initialize="true"
                placeholder="請求除外時のみ選択" :clearable="true" :disabled="editMode" codeId="BILLING_EXCLUSION_DEP"/>
            </template>
          </template>
          <template v-else>
            <Blank />
          </template>
        </template>
        <template v-else>
          <Blank />
        </template>
      </div>
    </template>
    <template v-if='formMode === "search" || (!searchMode && (actionType === "1" || actionType === "8"))'>
      <el-divider />
      <div class="el-form--inline">
        <Callsign v-model="callsign" :searchCond="searchMode" :initialize="true" :required="!searchMode" :disabled="editDisabledMode && editMode" />
        <RouteCode v-model="routeCode" :searchCond="searchMode" :initialize="true" :required="!searchMode" :disabled="editDisabledMode && editMode" />
      </div>
      <div class="el-form--inline">
        <AirportCode v-model="departureAirportCode" label="出発地" prop="departure_airport_code" :searchCond="searchMode" :initialize="true" class="departure_airport_code"
          :autocomplete-list="autocompleteAirportCodeSet" :disabled='(actionType === "8" && !searchMode) || (editDisabledMode && editMode)' :required="!searchMode"/>
        <AirportCode v-model="destinationAirportCode" label="目的地" prop="destination_airport_code" :searchCond="searchMode" :initialize="true" class="destination_airport_code"
          :autocomplete-list="autocompleteAirportCodeSet" :disabled='(actionType === "1" && !searchMode) || (editDisabledMode && editMode)' :required="!searchMode"/>
      </div>
      <div class="el-form--inline">
        <FlightPurposeCode v-model="flightPurposeCode" :searchCond="searchMode" :required="!searchMode" :initialize="true" :disabled="editDisabledMode && editMode" />
        <Blank />
      </div>
    </template>
    <template v-if='formMode === "search" || formMode === "edit" '>
      <el-divider />
      <div class="el-form--inline">
        <ModelCode v-model="modelCode" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" :initialize="true"
          :autocomplete-list="autocompleteModelCodeSet" />
        <AircraftType v-model="aircraftType" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" :initialize="true" />
      </div>
      <template v-if='formMode === "search"'>
        <div class="el-form--inline">
          <Numeric v-model="weight" label="重量[t]" prop="weight" :required="!searchMode" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1" :disabled="editDisabledMode && editMode" />
          <Blank />
        </div>
      </template>
      <template v-else>
        <div class="el-form--inline">
          <Numeric v-model="weight" label="重量[t]" placeholder="0.1～999.9" prop="weight" :required="!searchMode" :searchCond="searchMode" :min="0.1" :max="999.9" :precision="1" :step="0.1" :disabled="editDisabledMode && editMode" />
          <Blank />
        </div>
      </template>
    </template>
    <template v-if='formMode === "search" || (!searchMode && actionType === "8")'>
      <el-divider />
      <template v-if='formMode === "search"'>
        <div class="el-form--inline">
          <Numeric v-model="stops" label="停留回数" prop="stops"
            :required="!searchMode" :searchCond="searchMode" :min="0" :max="999" :step="1" :disabled="editDisabledMode && editMode" />
          <Numeric v-model="stopMinutes" label="停留時間[分]" prop="stop_minutes"
            :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
        </div>
      </template>
      <template v-else>
        <div class="el-form--inline">
          <Numeric v-model="stops" label="停留回数" placeholder="0～999" prop="stops"
            :required="!searchMode" :searchCond="searchMode" :min="0" :max="999" :step="1" :disabled="editDisabledMode && editMode" />
          <Numeric v-model="stopMinutes" label="停留時間[分]" placeholder="0～999999" prop="stop_minutes"
            :required="!searchMode" :searchCond="searchMode" :min="0" :max="999999" :step="1" :disabled="editDisabledMode && editMode" />
        </div>
      </template>
      <div class="el-form--inline">
        <Taxation v-model="taxation" :required="!searchMode" :searchCond="searchMode" :initialize="true" :disabled="editDisabledMode && editMode" />
        <template v-if='formMode === "search"'>
          <Numeric v-model="tax" label="税率[%]" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
        </template>
        <template v-else-if='formMode === "edit"'>
          <Numeric v-model="tax" label="税率[%]" placeholder="0～99" prop="tax" :required="!searchMode" :disabled="editMode" :searchCond="searchMode" :min="0" :max="99" :step="1" />
        </template>
        <template v-else>
          <Blank />
        </template>
      </div>
      <div class="el-form--inline">
        <Numeric v-model="unitFee" label="単位料金[円]" prop="unit_fee"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999999" :disabled="editDisabledMode && editMode" />
        <Numeric v-model="stopFeeWithoutTax" label="停留料(税抜)[円]" prop="stop_fee_without_tax"
          :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      </div>
      <div class="el-form--inline">
        <Numeric v-model="stopFeeTax" label="停留料(税)[円]" prop="stop_fee_tax"
          :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
        <Numeric v-model="stopFeeWithTax" label="停留料(税込)[円]" prop="stop_fee_with_tax"
          :required="!searchMode" :searchCond="searchMode" :min="-9999999" :max="9999999" :disabled="editDisabledMode && editMode" />
      </div>
    </template>
    <template v-if='formMode === "search"'>
      <div class="el-form--inline">
        <Blank />
        <div class="parent_Box">
          <div class="child_Box">
            <el-checkbox v-model="manualDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に補正登録データのみ表示する</el-checkbox>
          </div>
          <div class="child_Box">
            <el-checkbox v-model="automaticDataOnly" v-if="searchMode" :searchCond="searchMode" >検索結果に自動入力データのみ表示する</el-checkbox>
          </div>
        </div>
      </div>
    </template>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import DateTimeRange from '@/components/molecules/form/date/DateTimeRange.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import Callsign from '@/components/molecules/form/text/Callsign.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import ModelCode from '@/components/molecules/form/autocomplete/ModelCode.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
// import Tax from '@/components/molecules/form/number/Tax.vue'
import Taxation from '@/components/molecules/form/select/Taxation.vue'
import FlightPurposeCode from '@/components/molecules/form/select/FlightPurposeCode.vue'
import AircraftType from '@/components/molecules/form/select/AircraftType.vue'
// import Weight from '@/components/molecules/form/number/Weight.vue'
// import Count from '@/components/molecules/form/number/Count.vue'
// import Minutes from '@/components/molecules/form/text/Minutes.vue'
import ActionType from '@/components/molecules/form/select/ActionType.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'
import BillingExclusion from '@/components/molecules/form/select/BillingExclusion.vue'

export default {
  components: {
    BillingYm,
    RegistrationSymbol,
    DateTimeRange,
    DateTime,
    BillToCode,
    RouteCode,
    Callsign,
    AirportCode,
    ModelCode,
    Numeric,
    // Tax,
    Taxation,
    FlightPurposeCode,
    AircraftType,
    // Weight,
    // Count,
    // Minutes,
    ActionType,
    Blank,
    BillingExclusion
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    registrationSymbol: {
      get () {
        return this.model.registration_symbol
      },
      set (registrationSymbol) {
        const form = { ...this.model }
        form.registration_symbol = registrationSymbol
        this.$emit('input', form)
      }
    },
    actionType: {
      get () {
        return this.model.action_type
      },
      set (actionType) {
        const form = { ...this.model }
        form.action_type = actionType
        this.$emit('input', form)

        if (!this.searchMode) {
          form.destination_airport_code = ''
          form.departure_airport_code = ''
          if (actionType === '1' || actionType === '8') {
            if (actionType === '1') {
              form.destination_airport_code = this.getDefaultOwnAirport()
            }
            if (actionType === '8') {
              form.departure_airport_code = this.getDefaultOwnAirport()
            }
          }
        }
      }
    },
    actionTime: {
      get () {
        return this.model.action_time
      },
      set (actionTime) {
        const form = { ...this.model }
        form.action_time = actionTime
        this.$emit('input', form)
      }
    },
    actionTimeFrom: {
      get () {
        return this.model.action_time_from
      },
      set (actionTimeFrom) {
        const form = { ...this.model }
        form.action_time_from = actionTimeFrom
        this.$emit('input', form)
      }
    },
    actionTimeTo: {
      get () {
        return this.model.action_time_to
      },
      set (actionTimeTo) {
        const form = { ...this.model }
        form.action_time_to = actionTimeTo
        this.$emit('input', form)
      }
    },
    billToCode: {
      get () {
        return this.model.bill_to_code
      },
      set (billToCode) {
        const form = { ...this.model }
        form.bill_to_code = billToCode
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    callsign: {
      get () {
        return this.model.callsign
      },
      set (callsign) {
        const form = { ...this.model }
        form.callsign = callsign
        this.$emit('input', form)
      }
    },
    departureAirportCode: {
      get () {
        return this.model.departure_airport_code
      },
      set (departureAirportCode) {
        const form = { ...this.model }
        form.departure_airport_code = departureAirportCode
        this.$emit('input', form)
      }
    },
    destinationAirportCode: {
      get () {
        return this.model.destination_airport_code
      },
      set (destinationAirportCode) {
        const form = { ...this.model }
        form.destination_airport_code = destinationAirportCode
        this.$emit('input', form)
      }
    },
    modelCode: {
      get () {
        return this.model.model_code
      },
      set (modelCode) {
        const form = { ...this.model }
        form.model_code = modelCode
        this.$emit('input', form)
      }
    },
    stopFeeWithoutTax: {
      get () {
        return this.model.stop_fee_without_tax
      },
      set (stopFeeWithoutTax) {
        const form = { ...this.model }
        form.stop_fee_without_tax = stopFeeWithoutTax
        this.$emit('input', form)
      }
    },
    stopFeeTax: {
      get () {
        return this.model.stop_fee_tax
      },
      set (stopFeeTax) {
        const form = { ...this.model }
        form.stop_fee_tax = stopFeeTax
        this.$emit('input', form)
      }
    },
    stopFeeWithTax: {
      get () {
        return this.model.stop_fee_with_tax
      },
      set (stopFeeWithTax) {
        const form = { ...this.model }
        form.stop_fee_with_tax = stopFeeWithTax
        this.$emit('input', form)
      }
    },
    tax: {
      get () {
        return this.model.tax
      },
      set (tax) {
        const form = { ...this.model }
        form.tax = tax
        this.$emit('input', form)
      }
    },
    taxation: {
      get () {
        return this.model.taxation
      },
      set (taxation) {
        const form = { ...this.model }
        form.taxation = taxation
        this.$emit('input', form)
      }
    },
    flightPurposeCode: {
      get () {
        return this.model.flight_purpose_code
      },
      set (flightPurposeCode) {
        const form = { ...this.model }
        form.flight_purpose_code = flightPurposeCode
        this.$emit('input', form)
      }
    },
    aircraftType: {
      get () {
        return this.model.aircraft_type
      },
      set (aircraftType) {
        const form = { ...this.model }
        form.aircraft_type = aircraftType
        this.$emit('input', form)
      }
    },
    weight: {
      get () {
        return this.model.weight
      },
      set (weight) {
        const form = { ...this.model }
        // form.weight = String(Math.floor(weight, 0.01))
        form.weight = weight
        this.$emit('input', form)
      }
    },
    stops: {
      get () {
        return this.model.stops
      },
      set (stops) {
        const form = { ...this.model }
        form.stops = stops
        this.$emit('input', form)
      }
    },
    stopMinutes: {
      get () {
        return this.model.stop_minutes
      },
      set (stopMinutes) {
        const form = { ...this.model }
        form.stop_minutes = stopMinutes
        this.$emit('input', form)
      }
    },
    manualDataOnly: {
      get () {
        return this.model.manual_data_only
      },
      set (manualDataOnly) {
        const form = { ...this.model }
        form.manual_data_only = manualDataOnly
        this.$emit('input', form)
        if (manualDataOnly === true) {
          form.automatic_data_only = false
        }
      }
    },
    automaticDataOnly: {
      get () {
        return this.model.automatic_data_only
      },
      set (automaticDataOnly) {
        const form = { ...this.model }
        form.automatic_data_only = automaticDataOnly
        this.$emit('input', form)
        if (automaticDataOnly === true) {
          form.manual_data_only = false
        }
      }
    },
    unitFee: {
      get () {
        return this.model.unit_fee
      },
      set (unitFee) {
        const form = { ...this.model }
        form.unit_fee = unitFee
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    },
    billingExclusion: {
      get () {
        return this.model.billing_exclusion_flag
      },
      set (billingExclusion) {
        const form = { ...this.model }
        if (billingExclusion === '') { billingExclusion = undefined }
        form.billing_exclusion_flag = billingExclusion
        this.$emit('input', form)
      }
    }
    // editDisabledMode: {
    //   get () {
    //     return this.model.regist_type === '1' || parseInt(this.model.billing_ym) < parseInt(this.getDefaultBillingYm())
    //   }
    // }
  },
  mounted () {
  },
  methods: {
    changeActionType (sel) {
      // if (!this.searchMode) {
      const obj = document.getElementsByClassName('airport-code')
      for (var i = 0; i < obj.length; i++) {
        // 要素からclass="is-required"を削除する
        obj[i].classList.remove('is-required')
        if (!this.searchMode || !this.editDisabledMode) {
          // if ((sel === '1' && i === 0) || (sel === '8' && i === 1)) {
          if ((sel === '1' && obj[i].className.match(/departure/)) || (sel === '8' && obj[i].className.match(/destination/))) {
            // 要素にclass="is-required"を追加する
            obj[i].classList.add('is-required')
          }
        }
      }
    },
    clearFields () {
      this.changeActionType(this.model.action_type)
      this.$refs.feesForStopForm.resetFields()
      this.billingYm = this.getDefaultBillingYm()
      if (this.searchMode) {
        this.model.action_time_from = null
        this.model.action_time_to = null
        this.model.manual_data_only = false
        this.model.automatic_data_only = false
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForStopForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.fees-for-stop-form {
  .el-form--inline {
    display: flex;
    justify-content: space-between;
    // margin-left: 10px;
  }
  .el-form-item.date-time-range{
    .el-input__inner{
      width: 47em;
    }
  }
  .el-form-item.date-time{
    .el-input__inner{
      padding-right: 14px
    }
  }
  .parent_Box{
    padding-right: 34px
  }
}

</style>
